/*
  Что видит владелец платформы, открывший кабинет заказчика.

  Его роль сквозная: она видит данные всех заказчиков сразу, и работа внутри
  одной организации ей намеренно закрыта — иначе действия владельца платформы
  смешались бы в журнале с действиями сотрудников. Разрешений у роли ноль, и
  до 10.09.2026 кабинет встречал её красной плашкой «У вашей роли нет доступа
  к этому разделу»: технически верно, а по сути — вид поломки на ровном месте.

  Поэтому здесь не отказ, а указание дороги: панель платформы живёт по своему
  адресу и со своим входом.
*/

const ADMIN_URL = '/admin'

export default function PlatformAdminPage({ profile, onLogout }) {
  // Обращение собирается одной строкой, а не склейкой из двух узлов разметки:
  // «…Борисович, в» и «аша роль» выглядят слитно только на экране, а читалке
  // достаются двумя кусками.
  const greeting = profile?.full_name
    ? `${profile.full_name}, ваша роль управляет платформой целиком`
    : 'Ваша роль управляет платформой целиком'

  return (
    <div className="gate">
      <h1 className="gate__title">Вы вошли как владелец платформы</h1>
      <p className="gate__text">
        {greeting}: организациями, правовыми пакетами и текстами на согласование. Она живёт в
        отдельной панели - у неё свой адрес и свой вход.
      </p>
      <p className="gate__text">
        Кабинет заказчика этой роли закрыт намеренно, а не по ошибке доступа: владелец платформы
        видит данные всех организаций сразу, и вести в одной из них ежедневную работу - значит
        смешивать это в журнале действий. Чтобы пройти путь заказчика, нужна учётная запись
        внутри организации: руководителя, юриста или оператора.
      </p>
      <div className="gate__actions">
        <a className="button" href={ADMIN_URL}>
          Открыть панель платформы
        </a>
        <button className="button button--ghost" type="button" onClick={onLogout}>
          Выйти
        </button>
      </div>
    </div>
  )
}
